"use client";

import { Layout } from 'antd';
import styles from './Tools.module.scss';
import { AutoScrollCarousel } from '@/shared/ui/AutoScrollCarousel';
import { useTranslations } from 'next-intl';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import { DiamondPlusIcon } from '@/shared/constants/icon';

const { Content } = Layout;

const toolsData = [
  {
    id: 1,
    title: 'title1',
    desc: 'desc1',
  },
  {
    id: 2,
    title: 'title2',
    desc: 'desc2',
  },
  {
    id: 3,
    title: 'title3',
    desc: 'desc3',
  },
  {
    id: 4,
    title: 'title4',
    desc: 'desc4',
  },
  {
    id: 5,
    title: 'title5',
    desc: 'desc5',
  },
  {
    id: 6,
    title: 'title6',
    desc: 'desc6',
  },
  {
    id: 7,
    title: 'title7',
    desc: 'desc7',
  },
  {
    id: 8,
    title: 'title8',
    desc: 'desc8',
  },
];

export const Tools = () => {
  const tKey = 'drawingOnline.tools';
  const t = useTranslations(tKey);

  return (
    <Content className={styles.root}>
      <ScrollReveal className={styles.root_title}>
        <h1>{t('title')}</h1>
        <h5>{t('desc')}</h5>
      </ScrollReveal>

      <AutoScrollCarousel
        data={toolsData}
        tKey={tKey}
        width="18vw"
        icon={<DiamondPlusIcon color="var(--color-primary)" size={'2.5vw'} />}
      />
    </Content>
  );
};
